import React, { ReactNode } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  size = 'md' 
}) => {
  if (!isOpen) return null;

  const sizeClasses: Record<string, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
  };

  return (
    <div 
      className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center z-50 p-4"
      onClick={onClose} // Close on backdrop click
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div 
        className={`relative bg-white rounded-lg shadow-xl p-6 ${sizeClasses[size]} w-full`}
        onClick={e => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4 pb-3 border-b">
          <h3 id="modal-title" className="text-lg font-medium text-gray-900">{title}</h3>
          <button 
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <span className="sr-only">Закрыть</span>
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
        
        {/* Modal Body */}
        <div className="max-h-[70vh] overflow-y-auto pr-2">
            {children}
        </div>
      </div>
    </div>
  );
};

export default Modal; 